// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedPatients_root__G2c4A"};